import { render, staticRenderFns } from "./hex-color-picker.component.vue?vue&type=template&id=31f92d08&scoped=true&"
import script from "./hex-color-picker.component.vue?vue&type=script&lang=ts&"
export * from "./hex-color-picker.component.vue?vue&type=script&lang=ts&"
import style0 from "./hex-color-picker.component.vue?vue&type=style&index=0&id=31f92d08&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f92d08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VColorPicker,VMenu,VRow,VTextField})
